import { render, staticRenderFns } from "./CreatePlusTemplate.vue?vue&type=template&id=cb746f58&scoped=true&"
import script from "./CreatePlusTemplate.vue?vue&type=script&lang=js&"
export * from "./CreatePlusTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CreatePlusTemplate.vue?vue&type=style&index=0&id=cb746f58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb746f58",
  null
  
)

export default component.exports